import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { isLoggedIn } from "utils";


export const getAssignedSubjects = async (data) => {
  return decryptData(
    await axios.get(
      `/subject-assigned-to-course?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const assignSubjectsToCourse = async (data) => {
  return decryptData(
    await axios.post(`/subject-assign-to-course`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};

export const getAssignedCourse = async (data) => {
  return decryptData(
    await axios.get(
      `/affiliate-assigned-courses?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getMasterCourses = async () => {
  return decryptData(
    await axios.get(
      `/affiliate-unassigned-courses?reqData=${encryptData({
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getBillingCourses = async () => {
  return decryptData(
    await axios.get(
      `/get-billing-courses?reqData=${encryptData({
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getBillingCoursesForBalancePayment = async () => {
  return decryptData(
    await axios.get(
      `/get-billing-courses-for-balance-payment?reqData=${encryptData({
        access_token: isLoggedIn(),
      })}`
    )
  );
};


export const assignCourseToAffiliate = async (data) => {
  return decryptData(
    await axios.post(`/add-courses-to-affiliates`, {
      reqData: encryptData({
        ...data,
        access_token: isLoggedIn(),
      }),
    })
  );
};